import { useEffect, useState } from "react";
import ButtonChat from "../futureChat/buttons/ButtonChat";

export function NetworkGuard({
    children,
}: {
    children: React.ReactNode;
}) {
    const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);

    useEffect(() => {
        function handleOnline() {
            setOnline(true);
        }
        function handleOffline() {
            setOnline(false);
        }

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    if (!online) {
        return <OfflineScreen />;
    }

    return <>{children}</>;
}

function OfflineScreen() {
    return (
        <div
            className="z-[999999] flex items-center justify-center bg-neutral-300 fixed w-screen h-screen flex-col text-black"
        >
            <div className="text-[64px] 4k:text-[256px]" >🦖</div>
            <p className="text-[24px] font-frutigerBold 4k:text-[96px]">Keine Internetverbindung</p>
            <p className="text-[18px] font-frutigerRoman 4k:text-[72px]">
                Prüfe deine Verbindung
            </p>
            <div className="absolute bottom-[20%] w-full px-[20%]">
                <ButtonChat
                    variant="primary"
                    onClick={() => window.location.reload()}
                >
                    Neu laden
                </ButtonChat>
            </div>
        </div>
    );
}
